import { type Pager, type PagerResponse } from '../types';

export default function pagerSerializer(pager: PagerResponse): Pager {
  return {
    total: pager?.total,
    limit: pager?.ps === -1 ? 'all' : pager?.ps,
    offset: pager?.rs,
  };
}
